//
// Module for the Death Setup wizard's Recalc Choose Recipients step
//
rs.module("participant/benefit/setup/death/wizard/recalcchooserecipientsstep",

    [ ],

    function () {

        // Initialize the module
        function initialize(hasBusinessWarning) {

            // Get the wizard's next button and disable it if there is a business warning that first needs approved by the user
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            wizardNextButton.setDisabled(hasBusinessWarning);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);